
import React from 'react';
import {ArrowRight, SquareMenuIcon} from 'lucide-react';

import {assets} from "../../assets/assets";
import {motion} from "framer-motion";


export default function ConstructionLandingPage() {

    return (

        <main>
            <section className="relative min-h-screen bg-[#062B63] overflow-hidden">

                <button
                    type="button"
                    className="
        absolute
        top-8
        right-8
        z-50
        flex
        items-center
        justify-center
        text-white
        transition-all
        duration-300
        hover:text-[#FFC400]
    "
                    aria-label="Open menu"
                >
                    <SquareMenuIcon
                        size={42}
                        strokeWidth={1.5}
                    />
                </button>

                {/* LEFT — Construction Image */}
                <div className="absolute inset-0 lg:w-[62%]">

                    <motion.img
                        src={assets.kna_arial}
                        alt="Construction foundation drilling"
                        initial={{ scale: 1.05, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 1.2, ease: "easeOut" }}
                        className="
                h-full
                w-full
                object-cover
            "
                    />

                    {/* Image darkening */}
                    <div className="
            absolute
            inset-0
            bg-black/15
            lg:bg-gradient-to-r
            lg:from-transparent
            lg:via-transparent
            lg:to-[#062B63]
        " />
                </div>

                {/* =====================================================
        RIGHT — BRAND PANEL
    ===================================================== */}
                <div className="
        relative
        z-10
        ml-auto
        min-h-screen
        w-full
        lg:w-[48%]
        bg-[#062B63]
        flex
        items-center
    ">
                    <div className="
            w-full
            px-8
            py-24
            sm:px-12
            lg:px-16
            xl:px-24
        ">

                        {/* Logo */}
                        <motion.div
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7 }}
                            className="mb-16"
                        >
                            <img
                                src={assets.k_Solution_logo}
                                alt="K Solution"
                                className="w-[180px] sm:w-[200px] rounded-md"
                            />
                        </motion.div>


                        {/* Small Label */}
                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, delay: 0.15 }}
                            className="
                    mb-5
                    text-sm
                    font-semibold
                    uppercase
                    tracking-[0.25em]
                    text-[#FFC400]
                "
                        >
                            Construction Management Platform
                        </motion.p>


                        {/* Main Heading */}
                        <motion.h1
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.25 }}
                            className="
                    max-w-xl
                    text-4xl
                    font-bold
                    leading-[1.05]
                    tracking-tight
                    text-white
                    sm:text-5xl
                    md:text-6xl
                    xl:text-7xl
                "
                        >
                            Build Smarter.
                            <br />

                            <span className="text-[#FFC400]">
                    Manage Better.
                </span>
                        </motion.h1>


                        {/* Description */}
                        <motion.p
                            initial={{ opacity: 0, y: 25 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.4 }}
                            className="
                    mt-7
                    max-w-lg
                    text-base
                    leading-7
                    text-slate-300
                    sm:text-lg
                "
                        >
                        </motion.p>


                        {/* CTA */}
                        <motion.div
                            initial={{ opacity: 0, y: 25 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.55 }}
                            className="
                    mt-10
                    flex
                    flex-col
                    gap-4
                    sm:flex-row
                "
                        >

                            <a
                                href="/employeeLogin"
                                className="
                        inline-flex
                        items-center
                        justify-center
                        gap-3
                        rounded-md
                        bg-[#FFC400]
                        px-7
                        py-3.5
                        font-semibold
                        text-[#062B63]
                        transition-all
                        duration-300
                        hover:bg-[#FFD43B]
                        hover:shadow-lg
                    "
                            >
                                Get Started

                                <ArrowRight
                                    size={18}
                                    strokeWidth={2.5}
                                />
                            </a>

                        </motion.div>


                        {/* Bottom statement */}
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 1, delay: 0.9 }}
                            className="mt-20"
                        >

                            <div className="mb-5 h-px w-24 bg-[#FFC400]" />

                            <p className="
                    text-xs
                    uppercase
                    tracking-[0.2em]
                    text-slate-400
                ">
                                Project Management
                            </p>

                        </motion.div>

                    </div>

                </div>


                {/* =====================================================
        DECORATIVE YELLOW ACCENT
    ===================================================== */}
                <div className="
        absolute
        bottom-0
        left-[58%]
        hidden
        h-24
        w-1
        bg-[#FFC400]
        lg:block
    " />

            </section>
        </main>
    )

}